import {
  FormErrorTypes,
  IPriceRange,
  validatePrice,
  InputPhoneValue,
} from "dash-ui";
import {
  DashValidation,
  isUrlValid,
  isEmailValid,
  isEmptyOrNil,
  isNameLengthValid,
  isDescriptionLengthValid,
} from "dash-common";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { FormContext } from "dash-ui";

import { FormFields } from "containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/constants/constants";

const useValidation = () => {
  const { errorHandlers } = useContext(FormContext);
  const { t } = useTranslation(["forms", "common", "pages"]);

  const resetPricesErrors = () => {
    errorHandlers[FormFields.Prices](null);
  };

  const validateFieldByName = (
    fieldName: FormFields,
    value: string | IPriceRange | any[] | InputPhoneValue,
    isMarketOptional: boolean = true
  ) => {
    const setInvalid = (message: string, values?: Record<string, string>) => {
      errorHandlers[fieldName]({
        type: FormErrorTypes.Invalid,
        message: t(message, values || {}),
      });
    };

    // check specific fields type
    switch (fieldName) {
      case FormFields.Name: {
        if (isEmptyOrNil(value as string)) {
          setInvalid(`forms:messages.nameBlank`);
          return false;
        }
        if (!isNameLengthValid(value as string)) {
          setInvalid("forms:messages.maxCharacterLimit", {
            number: DashValidation.MaxNameLength.toString(),
          });
          return false;
        }
        break;
      }
      case FormFields.DefaultInventoryDetails: {
        if (value) {
          if (!isDescriptionLengthValid(value as string)) {
            setInvalid("forms:messages.maxCharacterLimit", {
              number: DashValidation.MaxNameLength.toString(),
            });
            return false;
          }
        }
        break;
      }
      case FormFields.Website: {
        if (value && !isUrlValid(value as string)) {
          setInvalid("forms:messages.urlInvalid");
          return false;
        }
        break;
      }
      case FormFields.ContactEmail: {
        if (value && !isEmailValid(value as string)) {
          setInvalid("forms:messages.emailInvalid");
          return false;
        }
        break;
      }
      case FormFields.Market: {
        if (!isMarketOptional && isEmptyOrNil(value as string)) {
          setInvalid("forms:messages.marketBlank");
          return false;
        }
        break;
      }
      case FormFields.Prices: {
        const { min, max } = value as IPriceRange;
        if (!validatePrice(min, max)) {
          setInvalid("forms:messages.startingPriceMoreThanHighest");
          return false;
        }
        resetPricesErrors();
        break;
      }
      case FormFields.ContactPhone: {
        if (value) {
          const { dialCode, number } = value as InputPhoneValue;
          if (number) {
            if (dialCode === "+1" && number?.length !== 10) {
              setInvalid("forms:messages.phoneNumberWrongLengthUS");
              return false;
            }
          }
        }
        break;
      }
    }
    errorHandlers[fieldName](null);
    return true;
  };

  return validateFieldByName;
};

export default useValidation;
